export default __webpack_public_path__ + "static/media/Fang of the Vaaghasan.90901ef0.jpg";